// extracted by mini-css-extract-plugin
export var colorTexto = "DropDown-module--colorTexto--61170";
export var container = "DropDown-module--container--0edac";
export var container__drop = "DropDown-module--container__drop--bf4ca";
export var container_country = "DropDown-module--container_country--72f52";
export var dropdown__content = "DropDown-module--dropdown__content--5ab58";
export var img = "DropDown-module--img--dc5c0";
export var margin1 = "DropDown-module--margin1--20be7";
export var margin2 = "DropDown-module--margin2--441b1";
export var open = "DropDown-module--open--a815e";
export var rotate = "DropDown-module--rotate--0904d";
export var rotate2 = "DropDown-module--rotate2--ec113";
export var texto = "DropDown-module--texto--ae7ec";
export var title = "DropDown-module--title--42c0b";